import React, { useRef } from 'react'
import defaultQuestionImg from '../images/discussion-question-img.jpg'
import DialogueCommentTree from './dialogue-comment-tree'
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { compose } from "redux";
import {withTranslations} from "../decorators/with-translations"
import { FaLock } from 'react-icons/fa'
import ServerImage from './server-image'

const DialogueQuestionBlock = ({
  closed,
  topicClosed,
  title,
  questionNum,
  comments,
  image,
  id,
  useTranslate,
  isAfterGameGuest
}) => {

  const t = (phrase) => useTranslate(`discussion.${phrase}`);

  if (topicClosed) {
    closed = topicClosed;
  }

  const disableActions = closed;
  const inputRef = useRef(null);

  return (
    <div className={`discussion-question ${closed ? "closed" : ""} ${disableActions ? "actions-disabled" : ""}`}>
      <div className="question-header">
        <div className="row">

          <div className="col col-img">
            <div className="question-img">
              {image ? (
                <ServerImage image={image}>
                  {({ uri }) => (
                    <img className="nav-logo" src={uri} alt="" />
                  )}
                </ServerImage>
              ) : (
                <img src={defaultQuestionImg} alt="People"/>
              )}
            </div>
          </div>

          <div className="col col-info">
            <p className="question-num">
              {closed && <FaLock/>}
              {t("question")} {questionNum + 1}
            </p>
            <h3 className="question-title">{title}</h3>
            <div className="question-meta">
              {comments.length} {t("answer_amount")}
            </div>
          </div>
        </div>
      </div>

      <div className="comments-section">
        <DialogueCommentTree
          questionId={id}
          commentData={comments}
          inputRef={inputRef}
          isAfterGameGuest={isAfterGameGuest}
          disableActions={disableActions}
        />
      </div>

    </div>
  )
}

export default compose(
  withRouter,
  withTranslations,
  connect(null, null)
)(DialogueQuestionBlock)



// WEBPACK FOOTER //
// ./src/components/dialogue-question-block.js